import { Box, Typography } from "@mui/material";

interface IProps {
    /**
     * Main text of the subheader
     */
    subHeader?: string;
    /**
     * Optional subtitle or description
     */
    subtitle?: string;
}

/**
 * SubHeader component for section titles within a page
 * Displays a prominent subheader with optional subtitle
 */
export const SubHeader = ({ subHeader, subtitle }: IProps) => {
    return (
        <Box sx={{ backgroundColor: "#f8fafc", px: { xs: 2, sm: 3 }, pt: 1.5 }}>
            {/* Subheader */}
            {subHeader && (
                <Typography
                    variant="h6"
                    component="h2"
                    color="primary"
                    sx={{
                        fontWeight: 700,
                        mt: 1,
                        mb: 0.5,
                    }}
                >
                    {subHeader}
                </Typography>
            )}

            {subtitle && (
                <Typography variant="body2" color="text.secondary">
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
};
